const state = () => {
    return {
        page: {
            id: 0,
            content: [],
            blocks: [],
            topnews: [],
            currency: false,
            topnewsbysection: {}
        }
    }
}

// getters
const getters = {
    page: function (state) {
        return state.page
    },
    blocks: function (state) {
        return state.page.content
    },
    currencies: function (state) {
        return state.page.currency ? state.page.currency : false
    },
    inOtherMedia: function (state) {
        return state.page.additionalInfo ? state.page.additionalInfo['in-other-media'] : state.page.additionalInfo['in-other-media']
    },
    topNews: function (state) {
        return Object.values(state.page.topnews)
    },
    topNewsBySection: (state) => (section) => {
        if (state.page.topnewsbysection && state.page.topnewsbysection[section]) {
            return state.page.topnewsbysection[section];
        } else {
            return null;
        }
    },
    additionalInfo: function (state) {
        return state.page.additionalInfo || state.page.additionalInfo
    },
    alerts: function (state) {
        return (state.page.internalName) ? state.page.alerts || false : false;
    },
    votes: function (state) {
        var data = state.page.additionalInfo || state.page.additionalInfo
        return data ? data.votes : {}
    }
}

// actions
const actions = {
    async fetchPage({ commit }, { url, params = {} } ) {
        return this.client.Get(`/pages${url}`, {
                query: params,
                callback: function (response) {
                    commit('page', response);
                }
            }) 
    },
    async fetchAlerts({ commit }) {
        return this.client.Get(`/alert/news`, {
            callback: function (response) {
                commit('alerts', response);
            },
            progressbar: false
        })
    }
}

// mutations
const mutations = {
    page (state, response) {
        state.page = response
    },
    block (state, payload) {
        if (payload.block && payload.block.length > 0) payload = payload.block[0]
        if (!payload) return false

        const content = 'object' === typeof state.page.content ? Object.values(state.page.content) : state.page.content;

        content.forEach((block, index) => {
            if (block.id === payload.id) {
                state.page.content[index] = payload
            }
        });
    },
    addBlock (state, response) {
        state.page.content.push(response)
    },
    dropBlock (state, response) {
        state.page.content.forEach((block, index) => {
            if (response === block.id)
                state.page.content.splice(index, 1)
        })
    },
    clearBlocks (state) {
        state.page.content = []
        state.page.blocks = []
    },
    // reorder (state) {
    //     state.page.content = state.page.content.sort((a, b) => {
    //         return a.order < b.order ? -1 : 1
    //     })
    //     state.page.content.forEach((item, index) => {
    //         state.page.content[index].order = index + 1
    //     })
    // },
    currencies (state, response) {
        if (response && 0 < Object.entries(response).length)
            state.page.currency = response
    },
    content (state, { response, idBlock, idComponent }) {
        state.page.content.find(elem => elem.id === idBlock).components.find(elem => elem.id === idComponent).content = response;
    },
    status (state, { idBlock, idComponent }){
        state.page.content.find(elem => elem.id === idBlock).components.find(elem => elem.id === idComponent).status = !state.page.content.find(elem => elem.id === idBlock).components.find(elem => elem.id === idComponent).status
    },
    // unpublishAllInstances (state, {idBlock, idComponent}){
    //     state.page.content.find(elem => elem.id === idBlock).components.forEach(elem => {
    //         if(elem.id === idComponent)
    //             elem.status = 1
    //         else
    //             elem.status = 0
    //     });
    // },
    // topNewsBySection (state, {section, news}){
    //     state.page.topnewsbysection = {
    //         ...state.page.topnewsbysection,
    //         [section]: news
    //     };
    // },
    alerts(state, response) {
        state.page.alerts = response
    },
    votes: function (state, response) {
        return new Promise((resolve) => {
            state.page.additionalInfo.votes = response
            resolve(true);
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}